export default "__VITE_ASSET__c$kVBOYP__"